import UserInfoActions from '../../../../actions/UserInfoActions';
import store from '../../../../stores/redux';
import AppConstants from '../../../../constants/AppConstants';

const { dispatch } = store;
const actions = {
    saveStateServerStorage(store) {
        dispatch({
            type  : AppConstants.SERVER_STORAGE_SUCCESS,
            items : store
        });
    },

    saveServerStorage(metrics) {
        const storeServerStorage = store.getState().serverStorage.store;
        
        let newStoreServerStorage = {
            ...storeServerStorage,
            reportByReferral: {
                ...(storeServerStorage.reportByReferral || {}),
                metrics
            }
        };

        actions.saveStateServerStorage(newStoreServerStorage);
        
        const dataToSend = JSON.stringify(newStoreServerStorage);
        
        UserInfoActions.setServerStorage({
            data: dataToSend
        });
    },
};

export default actions;
